export default __webpack_public_path__ + "static/media/EditingMapsAdvanced.3593f8ba.jpg";